module.exports = __webpack_public_path__ + "static/media/logo_vietcombank.a172b699.svg";